import { Component, OnInit, Input, HostListener } from '@angular/core';
import { PostAttachments } from 'src/app/_models';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseComponent } from 'src/app/_base/base.component';

@Component({
  selector: 'app-post-image-view',
  templateUrl: './post-image-view.component.html',
  styleUrls: ['./post-image-view.component.scss']
})
export class PostImageViewComponent extends BaseComponent implements OnInit {
  @Input()
  postImages: PostAttachments[] = [];
  @Input()
  postIndex: number = null;
  activeImage: string = null;
  maxHeight: number;
  constructor(private modalRef: BsModalRef) {
    super();
  }

  ngOnInit() {
    this.imageInit();
    this.resize();
  }
  imageInit(): void {
    if (this.postIndex !== -1) this.activeImage = this.getImage(this.postImages[this.postIndex].attachmentFileName);
  }
  nextImage(): void {
    this.postIndex += 1;
    if (this.postIndex <= this.postImages.length - 1) {
      this.imageInit();
    } else {
      this.postIndex = 0;
      this.imageInit();
    }
  }
  previousImage(): void {
    this.postIndex -= 1;
    if (this.postIndex - 1 >= 0) {
      this.imageInit();
    } else {
      this.postIndex = this.postImages.length - 1;
      this.imageInit();
    }
  }
  modalClose() {
    this.modalRef.hide();
  }
  @HostListener('window:resize', ['$event'])
  resize(): void {
    if (window.innerHeight - 50 >= 500) this.maxHeight = window.innerHeight - 50;
    else this.maxHeight = window.innerHeight;
  }
}
